import styled from 'styled-components';

export const StyledControlBar = styled.div`
  align-items: center;
  background: ${props => props.theme.themeColors.controlBar.background};
  border-bottom: 1px solid
    ${({ theme }) => theme.themeColors.controlBar.borderBottomColor};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  height: 60px;
  justify-content: space-between;
  min-height: 60px;
  padding: 0 60px;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;
  z-index: 2000;
  @media all and (max-width: 1200px) {
    padding: 0 20px;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  align-items: center;
  @media all and (max-width: 1200px) {
    & > svg {
      display: none;
    }
  }
`;

export const RightPanel = styled.div`
  display: flex;

  & > *:not(:first-child) {
    margin-left: 32px;
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
  width: 30%;
  text-align: center;
  @media all and (max-width: 1200px) {
    display: none;
  }
`

export const StyledBookTitle = styled.div`
  color: ${props => props.theme.themeColors.sidebars.toc.textColor};
`;

export const StyledBookAuthors = styled.div`
  color: ${props => props.theme.themeColors.sidebars.toc.subTextColor};
  font-size: 14.22px;
`;

export const UpdateModal = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 4000 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999 !important;
    @media all and (max-width: 500px) {
      display: block; 
    }
`;

export const UpdateModalBody = styled.div`
    width: 400px;
  background-color: #fbfbfb;
  box-shadow: 2px 4px 8px 2px rgba(0, 0, 0, 0.2);
    padding: 30px;
    text-align: left;
    & h3 {
      margin-top: 0px;
    }
    @media all and (max-width: 500px) {
      height: 100%; 
    }
    & textarea {
      width: 100%;
      height: 100px;
    }
`;

export const UpdateModalFooter = styled.div`
    text-align: right;
`;

export const UpdateModalInput = styled.input`
    padding: 10px;
    background-color: #ffffff;
    border: 1px solid #000000;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 20px;
`;

export const UpdateModalBtnWhite = styled.button`
  padding: 10px 20px;
  background-color: rgba(255,255,255,0.5);
  border-radius: 5px;
  color: #000000;
  border: 1px solid #dedede;
  cursor: pointer;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    background-color: rgba(23, 125, 214, 0.2);    
  }
`;

export const UpdateModalBtn = styled.button`
  padding: 10px 20px;
  background-color: rgb(23, 125, 214);
  border-radius: 5px;
  color: #ffffff;
  border: 1px solid #dedede;
  cursor: pointer;
  margin-left: 10px;
  transition-duration: 200ms;
  &:hover {
    transition-duration: 200ms;
    opacity: 0.8;
  }
`;

export const StyledTitle = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;